import { getDomainCountry } from "../utils/getDomainCountry";

const TERMS_AND_CONDITIONS_URLs: Record<string, string> = {
  EG: 'https://paymob.com/click-by-paymob/',
  AE: 'https://paymob.ae/click-by-paymob/',
  SA: 'https://paymob.sa/click-by-paymob/',
  OM: 'https://om.paymob.com/click-by-paymob/',
};
 export const getTermsAndConditionsURL = () => {
  const country = getDomainCountry().iso
  return TERMS_AND_CONDITIONS_URLs[country]
}